import { render, staticRenderFns } from "./hosting-ftp-illustration.vue?vue&type=template&id=2c495b16"
import script from "./hosting-ftp-illustration.vue?vue&type=script&lang=js"
export * from "./hosting-ftp-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports